<template>
  <Command
    v-if="mediaPlayer?.state === MediaPlayerState.Paused"
    @click="mediaPlayer?.resume()"
  >
    <slot
      v-bind="{
        disabled: !mediaPlayer,
        icon: 'play_arrow',
        label: t('tts.controls.play'),
        toolTip: t('tts.controls.play'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import Command from "../command";
import MediaPlayer, { MediaPlayerState } from "@/services/media/player";

const { t } = useI18n();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer | null>;
</script>
